var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isThemeAdded,
          expression: "isThemeAdded"
        }
      ]
    },
    [
      _c("div", { staticClass: "app-wrapper", class: _vm.classObj }, [
        _c(
          "div",
          { staticStyle: { height: "57px" } },
          [
            _vm.isShowSidebar
              ? _c("sidebar", { staticClass: "sidebar-container" })
              : _vm._e(),
            _c("navbar", { on: { changeMainStyle: _vm.changeMainStyle } })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "main-container",
            style: { "margin-left": _vm.leftWith }
          },
          [_c("app-main")],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }